import { useEffect, useRef, useState } from 'react'
import { LANGUAGES } from '../../data/navigation'
import { useLanguage } from '../../hooks/useLanguage'
import { Flag } from '../Icon/Flag'
import { Icon } from '../Icon/Icon'
import styles from './LanguageSelect.module.scss'

interface LanguageSelectProps {
  className?: string
}

export const LanguageSelect = ({ className = '' }: LanguageSelectProps) => {
  const { changeLanguage, language } = useLanguage()
  const [open, setOpen] = useState(false)
  const rootRef = useRef<HTMLDivElement>(null)
  const current = LANGUAGES.find((item) => item.code === language) ?? LANGUAGES[0]

  useEffect(() => {
    if (!open) {
      return
    }
    const onPointerDown = (event: PointerEvent) => {
      if (rootRef.current && !rootRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }
    document.addEventListener('pointerdown', onPointerDown)
    return () => {
      document.removeEventListener('pointerdown', onPointerDown)
    }
  }, [open])

  return (
    <div ref={rootRef} className={`${styles.select} ${className}`.trim()}>
      <button
        aria-expanded={open}
        aria-haspopup="listbox"
        className={styles.trigger}
        type="button"
        onClick={() => {
          setOpen((prev) => !prev)
        }}
      >
        {current.label}
      </button>
      {open ? (
        <ul className={styles.menu} role="listbox">
          {LANGUAGES.map((item) => (
            <li key={item.code}>
              <button
                aria-selected={item.code === language}
                className={styles.option}
                role="option"
                type="button"
                onClick={() => {
                  changeLanguage(item.code)
                  setOpen(false)
                }}
              >
                <Flag code={item.flag} size={24} />
                <span>{item.label}</span>
                {item.code === language ? (
                  <Icon className={styles.check} name="check" size={20} />
                ) : null}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  )
}
